import { CerFormAdapter } from '@form/cer-form-adapter';

import { CerFormViewSet } from '@form/cer-form-view-set';
import { CerFormView } from '@form/cer-form-view';

export class VendorTaxGroupForm extends CerFormAdapter {

  public override viewSetInit(viewSet: CerFormViewSet) {
    viewSet.viewAdd(this.viewGet());
  }
  
  private viewGet(): CerFormView {
    
    const view = new CerFormView();
    view.viewMetadata = {
      name: 'vendor-tax-group', dataApiName: 'VendorTaxGroup', text: 'Kreditor momsgrupper', textSingular: 'Kreditor momsgruppe',
      primaryKey: 'num', titleFields: ['num', 'name'], baseFields: ['id', 'num', 'name'],
      allowCreate: false, allowEdit: false, allowDelete: false
    };

    view.fieldMetadata = [
      { fieldType: 'financeTaxCode', required: true }
    ];

    return view;
  }
}
